import type { Employee } from "../types";

interface EmployeeTableProps {
  employees: Employee[];
}

export function EmployeeTable({ employees }: EmployeeTableProps) {
  return (
    <div className="employee-table-wrap">
      <table className="employee-table">
        <thead>
          <tr>
            <th>氏名</th><th>部署</th><th>役職</th><th>メール</th><th>内線</th><th>在籍状態</th>
          </tr>
        </thead>
        <tbody>
          {employees.map((employee) => (
            <tr key={employee.id} className={employee.employmentStatus === "retired" ? "is-retired" : ""}>
              <td><strong>{employee.displayName}</strong></td>
              <td>{employee.department}</td>
              <td>{employee.role}</td>
              <td>{employee.email}</td>
              <td>{employee.extension}</td>
              <td>{employee.employmentStatus === "active" ? "在籍" : employee.employmentStatus === "retired" ? "退職" : "不明"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
